import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, ProgressBar, Spinner } from 'react-bootstrap';
import { caricaVideoPresentazione, statoVideoPresentazione, togliVideoPresentazione } from '../../../../api-client/appPlayer';

/*
 * Video di presentazione della struttura (sportid-docs, interventi del 7-8/10/2026, sez. E): verticale, al
 * massimo 10 secondi, l'app lo mostra una volta aprendo la scheda. Lo carica la struttura e lo approva
 * SportID; il super admin, dalla scheda della struttura (`clubId`), lo carica gia` approvato.
 * Finche` il nuovo non e` approvato, nell'app resta quello approvato prima.
 */

const STATO = { PENDING: 'In attesa di approvazione', REJECTED: 'Non approvato' };

const AnteprimaVerticale = ({ url, etichetta }) => (
    <div className="sid-video-verticale">
        <div className="sid-video-verticale__etichetta">{etichetta}</div>
        <video src={url} controls playsInline preload="metadata" />
    </div>
);

export const VideoPresentazione = ({ clubId, superAdmin = false }) => {
    const [stato, setStato] = useState(null);
    const [progresso, setProgresso] = useState(null);
    const [errore, setErrore] = useState('');
    const [confermaTogli, setConfermaTogli] = useState(false);
    const input = useRef(null);

    const carica = async () => {
        const r = await statoVideoPresentazione(clubId);
        if (r?.error) { setErrore(r.error); setStato({}); return; }
        setStato(r);
    };
    useEffect(() => { carica(); }, [clubId]); // eslint-disable-line react-hooks/exhaustive-deps

    const scegli = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file) return;
        setProgresso(0);
        const r = await caricaVideoPresentazione(file, clubId, setProgresso);
        setProgresso(null);
        if (r?.error) { setErrore(r.error); return; }
        setStato(r);
    };

    const togli = async () => {
        setConfermaTogli(false);
        const r = await togliVideoPresentazione(clubId);
        if (r?.error) { setErrore(r.error); return; }
        setStato({});
    };

    if (!stato) return <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>;
    const { approved, review } = stato;

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Il video non va bene</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <Modal show={confermaTogli} onHide={() => setConfermaTogli(false)} centered>
                <Modal.Header closeButton><Modal.Title>Togliere il video di presentazione?</Modal.Title></Modal.Header>
                <Modal.Body>Sparisce dall'app, e anche quello in attesa di approvazione.</Modal.Body>
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => setConfermaTogli(false)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={togli}>Rimuovi</Button>
                </Modal.Footer>
            </Modal>

            <p className="sid-nota-leggibile">
                Verticale, MP4, al massimo <strong>10 secondi</strong>: l'app lo mostra una volta, aprendo la scheda.
                {!superAdmin && ' Prima di comparire lo approva SportID.'}
            </p>

            <div className="sid-video-verticale__fila">
                {approved && <AnteprimaVerticale url={approved.url} etichetta="Nell'app" />}
                {review && (
                    <div>
                        <AnteprimaVerticale url={review.url} etichetta={STATO[review.status] || review.status} />
                        {review.status === 'REJECTED' && review.rejectReason && (
                            <div className="mt-2"><strong>Motivo:</strong> {review.rejectReason}</div>
                        )}
                    </div>
                )}
                {!approved && !review && <div className="text-dark">Nessun video di presentazione.</div>}
            </div>

            {progresso !== null && <ProgressBar className="mt-3" now={Math.round(progresso * 100)} label={`${Math.round(progresso * 100)}%`} />}

            <div className="d-flex align-items-center gap-2 mt-3">
                {(approved || review) && (
                    <Button type="button" className="btn btn-outline-danger" onClick={() => setConfermaTogli(true)} disabled={progresso !== null}>Rimuovi video</Button>
                )}
                <span className="ms-auto" />
                <input ref={input} type="file" accept="video/mp4" hidden onChange={scegli} />
                <Button type="button" className="btn btn-primary" onClick={() => input.current?.click()} disabled={progresso !== null}>
                    {superAdmin ? 'Carica e approva' : approved || review ? 'Carica un altro video' : 'Carica il video'}
                </Button>
            </div>
        </>
    );
};

export default VideoPresentazione;
